import { render, staticRenderFns } from "./oauthGoogle.vue?vue&type=template&id=d404b5dc&"
import script from "./oauthGoogle.vue?vue&type=script&lang=js&"
export * from "./oauthGoogle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports